<ng-container *transloco="let t">
    <div class="pt-32-15 pb-300-100">
        @if (league?.id && currentStandingsMeta) {
        <app-league-results-table
            (onRaceTypeChange)="onRaceTypeChange($event)"
            [availableRaceTypes]="availableRaceTypes"
            [standingsMeta]="currentStandingsMeta"
            [leagueId]="league!.id!"
            [isAdmin]="false"
            [leagueEvents]="leagueEvents"
            [categoryItems]="categoryItems ?? []"
            [countries]="competitorsCountries ?? []"
        />
        }
    </div>
</ng-container>